export const styles = {
  titleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  buttonLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '16px',
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
  },
  icon: {
    color: 'inherit', // Inherits text color from parent element
  },
  buttonSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '10px',
    width: '306px',
  },
  buttonContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  editHint: {
    color: '#505050',
    fontFamily: '"Proxima Nova", sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    textAlign: 'center',
  },
  totalHeaderWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '16px',
    marginBottom: '10px',
    height: '32px',
  },
  totalHeaderItems: {
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
  },
  totalHeaderItem: {
    display: 'flex',
  },
  totalHeaderItemText: {
    fontFamily: '"Proxima Nova", sans-serif',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '22px',
    color: '#707087',
    marginRight: '10px',
  },
  totalHeaderItemValue: {
    fontFamily: '"Proxima Nova", sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#707087',
  },
}
